export const SkeletonCard = () => (
  <div className="animate-pulse bg-white shadow rounded-lg p-4 space-y-3">
    <div className="flex space-x-3">
      <div className="bg-gray-300 rounded-full h-12 w-12"></div>
      <div className="flex-1 space-y-2">
        <div className="h-4 bg-gray-300 rounded w-3/4"></div>
        <div className="h-4 bg-gray-300 rounded w-1/2"></div>
      </div>
    </div>
    <div className="h-60 bg-gray-300 rounded"></div>
  </div>
)